import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HealingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"healing"}/>
}
